import { render, staticRenderFns } from "./DvMinifySelect.vue?vue&type=template&id=0cfc9f22&scoped=true&lang=pug"
import script from "./DvMinifySelect.vue?vue&type=script&lang=js"
export * from "./DvMinifySelect.vue?vue&type=script&lang=js"
import style0 from "./DvMinifySelect.vue?vue&type=style&index=0&id=0cfc9f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc9f22",
  null
  
)

export default component.exports